import { useEffect as n } from "react";
import { useAuth as u } from "./use-auth.js";
const f = (i = {}) => {
  const { auth: e } = u(), { onAccessTokenExpired: t, onSilentRenewError: s, onUserLoaded: o, onUserUnloaded: d } = i;
  n(() => {
    if (!t) return;
    const r = e.events.addAccessTokenExpired(t);
    return () => {
      r();
    };
  }, [e.events, t]), n(() => {
    if (!s) return;
    const r = e.events.addSilentRenewError(s);
    return () => {
      r();
    };
  }, [e.events, s]), n(() => {
    if (!o) return;
    const r = e.events.addUserLoaded((c) => o(c));
    return () => {
      r();
    };
  }, [e.events, o]), n(() => {
    if (!d) return;
    const r = e.events.addUserUnloaded(d);
    return () => {
      r();
    };
  }, [e.events, d]);
};
export {
  f as useOidcEvents
};
